import api from './api';

const URLS = {
  fetchChartData: 'https://lw88cesr81.execute-api.eu-central-1.amazonaws.com/prod/getChartData',
};

export const fetchWorld = () => api.get(URLS.fetchChartData);

export const fetchCity = (city) => api.get(`${URLS.fetchChartData}?city=${city}`);
